<div class="w-full max-w-5xl mx-auto space-y-6">

  <!-- Page Header -->
  <div class="flex items-center justify-between pb-4 border-b border-slate-200">
    <div class="flex items-center gap-3">
      <div class="h-10 w-10 bg-slate-100 rounded-lg flex items-center justify-center">
        <mat-icon class="text-slate-600">person_add</mat-icon>
      </div>
      <div>
        <h2 class="text-sm font-bold tracking-widest uppercase text-slate-800">
          User Registration
        </h2>
        <p class="text-xs text-slate-500 font-medium mt-0.5">
          Manage user access and details
        </p>
      </div>
    </div>
  </div>

  <!-- FORM CARD -->
  <div class="bg-white rounded-xl shadow-sm border border-slate-200">

    <div class="p-8">
      <form #userForm="ngForm" (ngSubmit)="lFN_SubmitUser(userForm)">

        <!-- GRID LAYOUT -->
        <div class="grid grid-cols-1 md:grid-cols-2 gap-x-8 gap-y-6">

          <!-- Full Name -->
          <mat-form-field appearance="outline" class="w-full">
            <mat-label>Full Name</mat-label>
            <mat-icon matPrefix class="text-slate-400 mr-2">person</mat-icon>
            <input matInput name="fullName" [(ngModel)]="l_formDataUser.fullName" required maxlength="100"
              pattern="^[A-Za-z ]+$" #fullName="ngModel" placeholder="Ex. John Doe" />
            <mat-error *ngIf="userForm.submitted && fullName.invalid">
              Alphabets & spaces only (max 100)
            </mat-error>
          </mat-form-field>

          <!-- Login ID -->
          <mat-form-field appearance="outline" class="w-full">
            <mat-label>Login ID</mat-label>
            <mat-icon matPrefix class="text-slate-400 mr-2">badge</mat-icon>
            <input matInput name="loginId" [disabled]="isEditMode" autocomplete="off"
              [(ngModel)]="l_formDataUser.loginId" required maxlength="20" pattern="^[A-Za-z0-9]+$" #loginId="ngModel"
              placeholder="Ex. johndoe" />
            <mat-error *ngIf="userForm.submitted && loginId.invalid">
              Alphanumeric only, no spaces
            </mat-error>
          </mat-form-field>

          <!-- Password -->
          <mat-form-field appearance="outline" class="w-full">
            <mat-label>Password</mat-label>
            <mat-icon matPrefix class="text-slate-400 mr-2">lock</mat-icon>
            <input matInput autocomplete="new-password" [disabled]="isEditMode" [required]="!isEditMode"
              [type]="hidePassword ? 'password' : 'text'" name="password" [(ngModel)]="l_formDataUser.password"
              pattern="^(?=.*[A-Z])(?=.*\d)(?=.*[@$!%*?&])[A-Za-z\d@$!%*?&]{8,}$" #passwordInput="ngModel" />
            <button mat-icon-button matSuffix type="button" [disabled]="isEditMode"
              (click)="hidePassword = !hidePassword">
              <mat-icon class="text-slate-400">
                {{ hidePassword ? 'visibility_off' : 'visibility' }}
              </mat-icon>
            </button>
            <mat-error *ngIf="userForm.submitted && passwordInput.errors?.['required']">
              Password is required
            </mat-error>
            <mat-error *ngIf="userForm.submitted && passwordInput.errors?.['pattern']">
              Min 8 chars, 1 uppercase, 1 number & 1 special char
            </mat-error>
          </mat-form-field>

          <!-- Role -->
          <mat-form-field appearance="outline" class="w-full">
            <mat-label>Role</mat-label>
            <mat-icon matPrefix class="text-slate-400 mr-2">supervisor_account</mat-icon>
            <mat-select name="roleId" [(ngModel)]="l_formDataUser.roleId.roleId" required #roleId="ngModel">
              <mat-option value="0" disabled>Select Role</mat-option>
              <mat-option *ngFor="let role of roles" [value]="role.roleId">
                {{ role.roleName }}
              </mat-option>
            </mat-select>
            <mat-error *ngIf="roleId.invalid && userForm.submitted">
              Role is required
            </mat-error>
          </mat-form-field>

          <!-- Email -->
          <mat-form-field appearance="outline" class="w-full">
            <mat-label>Email ID</mat-label>
            <mat-icon matPrefix class="text-slate-400 mr-2">email</mat-icon>
            <input matInput type="email" name="email" [(ngModel)]="l_formDataUser.emailId" required email
              #email="ngModel" placeholder="Ex. john@example.com" />
            <mat-error *ngIf="userForm.submitted && email.invalid">
              Enter a valid email
            </mat-error>
          </mat-form-field>

          <!-- Phone -->
          <mat-form-field appearance="outline" class="w-full">
            <mat-label>Phone Number</mat-label>
            <mat-icon matPrefix class="text-slate-400 mr-2">phone</mat-icon>
            <input matInput type="tel" name="phone" [(ngModel)]="l_formDataUser.phoneNo" #phone="ngModel" required
              pattern="^[0-9]{10,15}$" minlength="10" maxlength="15" placeholder="Ex. 9876543210" />
            <mat-error *ngIf="phone.errors?.['required'] && userForm.submitted">
              Phone number is required
            </mat-error>
            <mat-error *ngIf="phone.errors?.['pattern'] && userForm.submitted">
              10-15 digits only
            </mat-error>
          </mat-form-field>

        </div>

        <!-- Footer Actions -->
        <div class="flex flex-col md:flex-row items-center justify-between gap-6 pt-8 mt-4 border-t border-slate-100">

          <!-- Active Checkbox -->
          <div class="flex items-center">
            <mat-checkbox name="isActive" [checked]="l_formDataUser.isActive !== 'NO'"
              (change)="l_formDataUser.isActive = $event.checked ? 'YES' : 'NO'">
              <span class="text-sm font-bold tracking-widest uppercase text-slate-800">
                {{ l_formDataUser.isActive !== 'NO' ? 'Active' : 'Inactive' }}
              </span>
            </mat-checkbox>
          </div>

          <!-- Buttons -->
          <div class="flex items-center gap-3 w-full md:w-auto">
            <button type="button" (click)="lFN_ResetForm(userForm)" class="flex-1 md:flex-none px-6 py-2.5 rounded-lg
                    text-slate-500 text-[12px] font-medium tracking-widest uppercase
                    bg-slate-100 text-slate-900
                    transition-all duration-200">
              Reset
            </button>

            <button type="submit" class="flex-1 md:flex-none px-8 py-2.5 rounded-lg
                    bg-slate-900 text-white text-[12px] font-medium tracking-widest uppercase
                    shadow-md hover:bg-slate-800 hover:shadow-lg
                    transition-all duration-200 flex items-center justify-center gap-2">
              <span>{{ isEditMode ? 'Update' : 'Save' }}</span>
            </button>
          </div>
        </div>

      </form>
    </div>
  </div>
</div>